/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { LoadConfigOkResult } from './LoadConfigOkResult'
import {
  LoadConfigOkResultFromJSON,
  LoadConfigOkResultFromJSONTyped,
  LoadConfigOkResultToJSON,
} from './LoadConfigOkResult'

/**
 *
 * @export
 * @interface LoadConfigResult
 */
export interface LoadConfigResult {
  /**
   *
   * @type {LoadConfigOkResult}
   * @memberof LoadConfigResult
   */
  success?: LoadConfigOkResult | null
  /**
   *
   * @type {string}
   * @memberof LoadConfigResult
   */
  error?: string | null
}

/**
 * Check if a given object implements the LoadConfigResult interface.
 */
export function instanceOfLoadConfigResult(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function LoadConfigResultFromJSON(json: any): LoadConfigResult {
  return LoadConfigResultFromJSONTyped(json, false)
}

export function LoadConfigResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LoadConfigResult {
  if (json === undefined || json === null) {
    return json
  }
  return {
    success: !exists(json, 'success')
      ? undefined
      : LoadConfigOkResultFromJSON(json['success']),
    error: !exists(json, 'error') ? undefined : json['error'],
  }
}

export function LoadConfigResultToJSON(value?: LoadConfigResult | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    success: LoadConfigOkResultToJSON(value.success),
    error: value.error,
  }
}
